window.MATS = window.MATS || {};

window.MATS.animateOnScroll = function (selector, animation, options = {}) {
  const settings = {
    delay: options.delay || 0,            // number in seconds (e.g., 2 for animate__delay-2s)
    threshold: options.threshold || 0.1,  // viewport % to trigger
    once: options.once !== false          // run only once by default
  };

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const elements = document.querySelectorAll(selector);

  const reveal = (el) => {
    if (!prefersReduced) {
      el.classList.add('animate__animated', `animate__${animation}`);

      // Add Animate.css delay class if delay > 0
      if (settings.delay > 0) {
        el.classList.add(`animate__delay-${settings.delay}s`);
      }
    } else {
      el.style.opacity = 1;
      el.style.transform = 'none';
    }
    if (settings.once) observer.unobserve(el);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        reveal(entry.target);
      }
    });
  }, {
    threshold: settings.threshold
  });

  elements.forEach(el => {
    el.style.opacity = 0; // hide until animation
    observer.observe(el);
  });
};
